import React, { useContext, useEffect, useState } from "react";
import useSnackbar from "./../../../hooks/useSnackbar";
import _ from "lodash";

import {
  Button,
  Divider,
  Grid,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  colors,
  Paper,
  IconButton,
  TextField
} from "@mui/material";

import { useTheme } from "@mui/material/styles";

import RefreshIcon from "@mui/icons-material/Refresh";

import ContainerLoading from "../../../components/Loading/ContainerLoading";

import { formatDate } from "../../../utils/misc";

import UpdateLogRow from "./SocketMonitor/UpdateLogRow";

import { KEY_NAME_REGEX } from "../../../constants";

import HttpContext from "../../../contexts/HTTP/HttpContext";

let env = require("../../../env");
const APP_URL = env.REACT_SCOCKETIO_URL;

function SocketMonitorAPI() {
  const theme = useTheme();
  const { get } = useContext(HttpContext);

  const [loading, setLoading] = useState(false);

  const [allLogs, setAllLogs] = useState([]);

  const { openSnackbar } = useSnackbar();

  const refresh = async () => {
    // Fetch and display socket info
    setLoading(true);
    const res = await get("/kiosk/getSockets");

    console.log("res", res);

    if (res.status != 200) {
      //Toast error
      openSnackbar({
        open: true,
        message: "Unable to load socket data",
        variant: "alert",
        alert: {
          color: "error"
        },
        close: false
      });
    }

    if (res.status == 403 || res.status == 401) {
      //logout and redirect to login
      await get("/logout");
      localStorage.removeItem("accessToken");
      window.location.href = "/login";
    }

    if (res.status == 200) {
      setAllLogs(res.data);
    }

    setLoading(false);
  };

  useEffect(() => {
    refresh();
  }, []);

  //console.log("allLogs", allLogs);

  return (
    <Grid
      style={{
        margin: theme.spacing(2),
        padding: theme.spacing(3),
        width: "100%",
        backgroundColor: colors.grey[100],
        borderRadius: "10px"
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            marginBottom: theme.spacing(2)
          }}
        >
          <Typography variant="h4">Socket Monitor</Typography>
          <Typography variant="h5" style={{ marginLeft: theme.spacing(2) }}>
            <span style={{ color: "grey" }}>
              ({allLogs.length} result{allLogs.length == 1 ? "" : "s"})
            </span>
          </Typography>
          {/* <Typography>Monitor socket connections and data</Typography> */}
        </div>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          marginTop: theme.spacing(2)
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: theme.spacing(1)
          }}
        >
          <div>
            <Button variant="contained" onClick={() => refresh()}>
              Refresh Info
            </Button>
          </div>
        </div>
      </div>

      <Divider
        style={{ marginBottom: theme.spacing(2), marginTop: theme.spacing(2) }}
      />
      <ContainerLoading show={loading} />
      <TableContainer>
        <Table
          style={{
            marginTop: theme.spacing(2),
            display: loading ? "none" : null
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell align="left">SocketID</TableCell>
              <TableCell align="left">Data</TableCell>
              <TableCell align="left">Rooms</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {allLogs ? (
              allLogs.map(row => <UpdateLogRow row={row} />)
            ) : (
              <>
                <div>No Data</div>
              </>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
}

export default SocketMonitorAPI;

function isKeyNameValid(name) {
  if (!name) return false;

  return KEY_NAME_REGEX.test(name);
}

function isKeyNameDuplicate(keys, name) {
  return keys.map(key => key.name).includes(name);
}

function getKeyNameHelperText(keys, name) {
  if (!isKeyNameValid(name)) {
    return "Invalid name";
  }

  if (isKeyNameDuplicate(keys, name)) {
    return "Name already in use";
  }

  return "";
}
